import * as types from './actionTypes';  
import messageUpdateApi from '../api/messageUpdateApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doUpdateMessage(request) {

  return {
    type: types.DO_UPDATE_MESSAGE,
    request
    
  };
}

export function doUpdateMessageRes(data) {  
  return {
    type: types.DO_UPDATE_MESSAGE_RES, 
    data
  };
}

export function UpdateMessage(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      messageUpdateApi.doUpdateMessage(request).then(data => {
        dispatch(doUpdateMessageRes(data));
        dispatch(doUpdateMessageRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}